
// import { faLuggageCart } from "@fortawesome/free-solid-svg-icons";
// import React from "react";
// import { useDispatch, useSelector } from "react-redux";

import { serverUrl, getheader, postMethodByDispatcher, setErrorDialog } from "../../../store/api/CommonFunctions";

export const nationalUrl = serverUrl + "api/CustomersAPI/SearchNationalCode";
export function GetStaffList(Name) {
  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: 'LOADING',
      data: true,
    })

    fetch(serverUrl + "api/CustomersApi/GetStaff/?name=" + Name, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {

        dispatch({
          type: 'LOADING',
          data: false,
        })
        return dispatch({
          type: "GET_STAFF",
          data: res
        })
      }).catch(err => console.error('[err]', err));
  };
}
export function AddNewCustomer(data, fn) {
  const _header = getheader();
  data.RegisteredFromSite = false;
  let customer = data;
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + "api/CustomersAPI/AddCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res === "ErrorMobile") {
          alert("کاربری با این شماره همراه در سیستم وجود دارد");
          return;
        }
        if (res === "ErrorPhone") {
          alert("کاربری با این شماره تلفن در سیستم وجود دارد");
          return;
        }
        if (res === "ErrorNationalCode") {
          alert("کاربری با این شماره ملی در سیستم وجود دارد");
          return;
        }
        customer.ID = Number(res);
        fn(customer);
        return dispatch({
          type: "ADD_CUSTOMER",
          data: res
        });
      }).catch(err => {
        console.error('[ADD_CUSTOMER]', err);
        alert("اشکال در انجام عملیات");
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }
}
export function editCustomerInfo(data, fn) {
  const _header = getheader();
  data.RegisteredFromSite = true;
  const editedInfo = data;
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + "api/CustomersAPI/EditCustomer/", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res === "ErrorNationalCode") {
          alert("کاربری با این شماره ملی در سیستم وجود دارد");
          return;
        }
        fn();
        dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: editedInfo
        });
        return dispatch({
          type: "Edit_CUSTOMER",
          data: res
        });
      }).catch(err => {
        console.error('[Edit_CUSTOMER]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  }
}
export function getCustomerInfo(fn) {
  const _header = getheader();
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerInfo", {
      headers: _header,
      mode: "cors",
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        return dispatch({
          type: "FETCH_CURRENT_CUSTOMER",
          data: resp
        })
      }).catch(err => {
        console.log("[FETCH_CURRENT_CUSTOMER]", err);
      })
  }
}
export function setNewPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    //let mobile = data.StringValue;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/SetNewPassword", {
      headers: getheader(),
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert("عملیات با موفقیت انجام شد. از نرم افزار خارج شده و دوباره وارد شوید");
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function forgetPassword(data, fn) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    let mobile = data.StringValue;
    data.ID = 0;
    data.Value = 0;
    data = JSON.stringify(data);
    fetch(serverUrl + "api/CustomersAPI/ForgetPassword", {
      headers: {
        // 'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'credentials': 'include'
      },
      body: data,
      method: "POST"
    }).then(resp => resp.json())
      .then(resp => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (resp === "Success") {
          localStorage.removeItem('token');
          alert(`رمز جدید به شماره موبایل ${mobile} ارسال شد`);
        }
        else if (resp.Message === "Error") {
          alert("اشکال در انجام عملیات");
        }
        else if (resp.Message === "NotFound") {
          alert("کاربری با این مشخصات در سیستم وجود ندارد");
        }
        else if (resp.Message === "IsBlackListed") {
          alert("این کاربری در لیست سیاه قرار دارد");
        }
        else if (resp.Message === "IsNotActive") {
          alert("این کاربری فعال نیست");
        }
        if (fn !== undefined) {
          fn();
        }
      }).catch(e => {
        dispatch({
          type: "LOADING",
          data: false
        });
        console.log("[REQUEST_PASS]", e);
        alert("اشکال در انجام عملیات");
      })
  }
}
export function setCustomerPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_CUSTOMER_POPUP",
      data: status
    });
  }
}
export function searchCustomer(data) {
  return dispatch => {
    if ((!data.Name || data.Name === "") &&
      (!data.Code || data.Code === "") &&
      (!data.NationalCode || data.NationalCode === "") &&
      (!data.Mobile || data.Mobile === "")) {
      alert("فیلدهای جستجو پر نشده است");
      return dispatch({
        type: "SEARCH_CUSTOMER",
        data: []
      });
    }
    dispatch({
      type: "SEARCH_CUSTOMER",
      data: "Pending"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerByFilter", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "SEARCH_CUSTOMER",
          data: res
        })
      }).catch(e => console.log("SEARCH_CUSTOMER", e));
  }
}
export function checkNationalCode(NationalCode) {
  if (NationalCode.length === 10) {
    if (NationalCode === '1111111111' ||
      NationalCode === '0000000000' ||
      NationalCode === '2222222222' ||
      NationalCode === '3333333333' ||
      NationalCode === '4444444444' ||
      NationalCode === '5555555555' ||
      NationalCode === '6666666666' ||
      NationalCode === '7777777777' ||
      NationalCode === '8888888888' ||
      NationalCode === '9999999999') {
      return false;
    }
    let c = parseInt(NationalCode.charAt(9));
    let n = parseInt(NationalCode.charAt(0)) * 10 +
      parseInt(NationalCode.charAt(1)) * 9 +
      parseInt(NationalCode.charAt(2)) * 8 +
      parseInt(NationalCode.charAt(3)) * 7 +
      parseInt(NationalCode.charAt(4)) * 6 +
      parseInt(NationalCode.charAt(5)) * 5 +
      parseInt(NationalCode.charAt(6)) * 4 +
      parseInt(NationalCode.charAt(7)) * 3 +
      parseInt(NationalCode.charAt(8)) * 2;
    let r = n - parseInt(n / 11) * 11;
    if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
      return false;
    }
    else {
      return true;
    }
  }
  else {
    return false;
  }

}
export function getCustomerCountReport() {
  return dispatch => {
    fetch(serverUrl + "api/CRMReportsAPI/GetCustomerCountReport", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "CUSTOMER_COUNT_REPORT",
          data: res
        });
      }).catch(e =>
        console.log("[CUSTOMER_COUNT_REPORT]", e)
      );
  }
}
export function getServiceEvents(serviceID, serviceType) {
  const data = { AttachmentID: serviceID, AttachmentType: serviceType, IsCustomer: true, IsPreCustomer: false, IsStaff: false };
  return dispatch => {
    dispatch({
      type: "SERVICE_EVENTS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/CustomersAPI/GetCustomerEvents", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "رویدادهای سرویس");
          res = null;
        }
        dispatch({
          type: "SERVICE_EVENTS",
          data: res
        });
      }).catch(e => {
        console.log("[SERVICE_EVENTS]", e);
      })
  }
}
export function getStaffEvents(data, onGetEvents) {
  return dispatch => dispatch(postMethodByDispatcher("api/CustomersAPI/GetCustomerEvents", data, "STAFF_EVENTS", "دریافت رویدادها", onGetEvents));

}
export function addNewEvent(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/AddCustomerEvent", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت رویداد");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت رویداد");
        if (fn) {
          fn(res);
        }
      })
  }
}
export function deleteEvent(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/CustomersAPI/DeleteEvent", {
      headers: getheader(),
      method: "POST",
      body: id
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف رویداد");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف رویداد");
        if (fn) {
          fn(res);
        }
      })
  }
}
